import { Tutorials } from '@/client/modules/Tutorials'
import { TutorialsProps } from '@/client/modules/Tutorials/types'
import { getCMSContent } from '@/client/utils'
import type { NextPage } from 'next'

const TutorialsPage: NextPage<TutorialsProps> = (data) => <Tutorials {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'TUTORIALS')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default TutorialsPage
